module.exports = __webpack_public_path__ + "img/image16.3b17f468.jpg";